import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import SearchOverlay from "./SearchOverlay";
import Announcement from "./Announcement";
import ChatWidget from "./ChatWidget";

export default function Layout({ children, transparentHeader = false }: { children: ReactNode; transparentHeader?: boolean }) {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-canvas">
      <Announcement />
      <Header />
      <main key={location.pathname} className={`route-fade ${transparentHeader ? "" : "pt-[88px] md:pt-[116px]"}`}>{children}</main>
      <Footer />
      <CartDrawer />
      <SearchOverlay />
      <ChatWidget />
    </div>
  );
}